import React from 'react';
import {
    newTextStyles,
    textStyles
} from '@honeybook/hbui/dist/components/HBText/HBText.styles';
import HBTooltip from '@honeybook/hbui/dist/components/HBTooltip/HBTooltip';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import { TActionBlocks } from '~/types/model.types';
import { getFlowActionBlockLabelsAsString } from '~/utils/flow.utils';
import colors from '@honeybook/hbui/dist/styles/colors';

type TTextType = keyof typeof textStyles | keyof typeof newTextStyles;
interface Props {
    actions: TActionBlocks[];
    maxVisibleActions?: number; // if none passing the default is all actions
    shouldUseToolTip?: boolean;
    typeForText?: TTextType;
    colorForText?: keyof typeof colors;
}

const FlowActions = ({
    actions,
    maxVisibleActions,
    shouldUseToolTip = false,
    typeForText = 'Body-Extra-small',
    colorForText = 'neutral900'
}: Props) => {
    const isShowToolTip =
        shouldUseToolTip && actions?.length > maxVisibleActions;

    const visibleActions = getFlowActionBlockLabelsAsString(
        actions,
        maxVisibleActions
    );
    const allActions =
        isShowToolTip && getFlowActionBlockLabelsAsString(actions);

    const displayActions = (
        <HBText type={typeForText} color={colorForText}>
            {actions?.length ? visibleActions : 'No actions'}
        </HBText>
    );
    return isShowToolTip ? (
        <HBTooltip maxWidth="200px" placement="top" target={displayActions}>
            {allActions}
        </HBTooltip>
    ) : (
        <>{displayActions}</>
    );
};

export default FlowActions;
